<mat-form-field class="form-field" [appearance]="appearance">
    
    <mat-label>
        Vertragstyp
    </mat-label>

    <mat-select [formControl]="valueControl">
        <mat-option *ngFor="let type of (contractTypes$|async)" [value]="type.contracttypeid">
            {{type.contracttypename}}
        </mat-option>
    </mat-select>

</mat-form-field>
